export default function CarreirAddress() {

  return (
      <p>آدرس های شرکت حمل</p>
  );
};